export const FeatureFlagEnum = {
  ShowMaintenanceMode: 'WEBAPP__Frontend__ShowMaintenanceMode',
}
